
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 62 47","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.383 23.266H8.95","fill":"none","stroke":"currentColor","stroke-width":"3.57"}}),_c('path',{attrs:{"d":"M23.09 39.146L7.351 23.266l15.74-15.882","fill":"none","stroke":"currentColor","stroke-width":"3.58"}})])
          )
        }
      }
    